var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"xs12":"","column":""}},_vm._l((_vm.contacts),function(c,i){return _c('div',{key:i},[_c('ContactCard',{attrs:{"name":c.name,"phoneNumbers":c.phoneNumbers,"url":c.url}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }